import { DateTime } from 'luxon'
import { dataOrDefault } from '.'

export function dateOrDefault(date: Date | undefined, default_value?: DateTime) {
  return date ? DateTime.fromJSDate(date) : dataOrDefault(default_value, DateTime.now())
}
